import { isBrowser } from 'services/language'

const STORAGE_KEY = 'schmidt-tracking-params'

const TRACKING_PARAMS = [
  'gclid',
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_term',
]

export const storeTrackingParams = () => {
  if (!isBrowser()) {
    return
  }

  const params = new URLSearchParams(window.location.search)
  const stored = getTrackingParams()
  const updated = { ...stored }

  TRACKING_PARAMS.forEach((key) => {
    const value = params.get(key)

    if (value) {
      updated[key] = value
    }
  })

  localStorage.setItem(STORAGE_KEY, JSON.stringify(updated))
}

export const getTrackingParams = () => {
  if (!isBrowser()) {
    return {}
  }

  try {
    const stored = localStorage.getItem(STORAGE_KEY)

    return stored ? JSON.parse(stored) : {}
  } catch {
    return {}
  }
}

const QUOTATION_FIELD_MAP = {
  2: {
    gclid: 'input_33',
    utm_source: 'input_34',
    utm_medium: 'input_35',
    utm_campaign: 'input_36',
    utm_term: 'input_37',
  },
  3: {
    gclid: 'input_30',
    utm_source: 'input_31',
    utm_medium: 'input_32',
    utm_campaign: 'input_33',
    utm_term: 'input_34',
  },
}

export const getQuotationTrackingFields = (formId) => {
  const params = getTrackingParams()
  const fieldMap = QUOTATION_FIELD_MAP[formId]

  if (!fieldMap) {
    return {}
  }

  return Object.fromEntries(
    TRACKING_PARAMS.map((key) => [fieldMap[key], params[key] || ''])
  )
}
